import type { AlgorithmExtension } from '@/engine/DataFlow/DataFlow';
import type { IValue } from '@/engine/DataFlow/Graph';
import type { KindParamsGetter, IParamsDescriptor } from '@/engine/app/CasePhaseData/interfaces.ts';

export interface ImportEntitiy {
  importName: string;
  algoName: string;
  isOptionalEntity: boolean;
  imagePhaseKind?: string;
}

export interface PhaseConfig {
  imageKinds: Set<string>;
  images: Array<{ kind: string; label: string }>;
  valuesCollection: Map<string, IValue>;
}

export interface ImportResult {
  phaseData: Map<string, PhaseConfig>;
  unlinkedMeshes: Map<string, string>;
  imageIdToDuplicateEntities: Map<string, Array<[string, string]>>;
  imagesWithoutObjects: Map<string, string>;
}

export interface ImageParams {
  perPhaseInfo: Array<IParamsDescriptor>;
  perKindGetter: KindParamsGetter;
  initialIndexParamName?: string;
  perKindInfo?: Array<IParamsDescriptor>;
}

export interface ImporterConfig {
  meshes: Array<ImportEntitiy>;
  points: Array<ImportEntitiy>;
  splines: Array<ImportEntitiy>;
  polylinesVectors: Array<ImportEntitiy>;

  algorithmBuilder: AlgorithmExtension;
  algorithmExtensions?: Map<string, AlgorithmExtension>;
  imageParams?: Map<string, ImageParams>;
  phaseWeightResolver?: (kind: string, label: string) => number | undefined;
  optionalImagePhaseKinds?: Array<string>;
}

export function importNamesMapping(array: Array<ImportEntitiy>): Map<string, Array<ImportEntitiy>> {
  const ret = new Map<string, Array<ImportEntitiy>>();
  for (const entry of array) {
    const existent = ret.get(entry.importName);
    if (existent) {
      existent.push(entry);
    } else {
      ret.set(entry.importName, [entry]);
    }
  }
  return ret;
}

export interface IImporter {
  import: (result: ImportResult, config: ImporterConfig) => Promise<void>;
}
